// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var $$default = (function (baseUrl) {
    return {
        fr: {
            Club: {
                home: 'Accéder à MonARTE',
                profile: 'Modifier mon profil',
                login: 'Se connecter',
                logout: 'Me déconnecter',
                pseudo: 'MonARTE',
            },
            Concert: {
                title: 'ARTE Concert',
                url: baseUrl + '/fr/arte-concert/',
                navigation: {
                    label: 'Menu ARTE Concert',
                    links: [
                        {
                            label: 'Musiques actuelles',
                            href: baseUrl + '/fr/arte-concert/musiques-actuelles/',
                            id: 'concert-modern',
                            kind: 'preference',
                            tracking: {
                                target: null,
                                click_name: 'Modern',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                        {
                            label: 'Musiques classiques',
                            href: baseUrl + '/fr/arte-concert/musiques-classiques/',
                            id: 'concert-classic',
                            kind: 'preference',
                            tracking: {
                                target: null,
                                click_name: 'Classic',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                        {
                            label: 'Parcourir les genres',
                            href: baseUrl + '/fr/arte-concert/plus-recentes/ ',
                            id: 'concert-genres',
                            kind: 'other',
                            tracking: {
                                target: null,
                                click_name: 'Parcourir_les_genres',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                        {
                            label: 'Agenda',
                            href: baseUrl + '/fr/arte-concert/agenda/',
                            id: 'guide',
                            kind: 'other',
                            tracking: {
                                target: null,
                                click_name: 'A_venir',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                    ],
                },
                socialNetworks:{
                    facebook: 'https://www.facebook.com/ARTEConcert',
                    twitter: "https://twitter.com/ARTEconcertFR",
                    instagram: "https://www.instagram.com/arteconcertfr/",
                    youtube: "https://www.youtube.com/c/arteconcert",
                    twitch: "https://www.twitch.tv/artefr?lang=fr",
                },
                concertSelectGenre:{
                    title:{label:"Parcourir les genres", href:baseUrl +"/fr/arte-concert/plus-recentes/"},
                    items:[
                        {
                            label:"Pop & Rock",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=pop-rock"
                        },
                        {
                            label:"Musiques Electroniques",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=musiques-electroniques"
                        },
                        {
                            label:"Hip-hop",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=hip-hop"
                        },
                        {
                            label:"Metal",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=metal"
                        },
                        {
                            label:"Classique",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=classique"
                        },
                        {
                            label:"Opéra",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=opera"
                        },
                        {
                            label:"Jazz",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=jazz"
                        },
                        {
                            label:"Musiques du monde",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=musiques-du-monde"
                        },
                        {
                            label:"Arts de la scène",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=arts-de-la-scene"
                        },
                        {
                            label:"Musique baroque",
                            href:baseUrl +"/fr/arte-concert/plus-recentes/?genres=musique-baroque"
                        },
                       
                    ]
                },
                guide: {label: 'Agenda',
                            href: baseUrl + '/fr/arte-concert/agenda/'},
            },
            LogoNavigation: {
                label: '',
                title: 'Arte, accueil',
                href: baseUrl + '/fr/',
            },
            DesktopNavigation: {
                ariaLabel: 'Menu secondaire',
                links: [
                    {
                        label: 'Guide TV',
                        href: baseUrl + '/fr/guide/',
                        id: 'guide',
                    },
                    {
                        label: 'Direct',
                        href: baseUrl + '/fr/direct/',
                        id: 'live',
                    },
                    {
                        label: 'Bientôt en ligne',
                        href: baseUrl + '/fr/p/a-venir/',
                        id: 'upcoming',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/fr/arte-concert/',
                        id: 'concert',
                        color: '#FF8BCA',
                        tracking: {
                            target: null,
                            click_name: 'arte_concert_button',
                            click_type: 'navigation',
                            categories: ['Header'],
                        },
                    },
                ],
            },
            Languages: {
                choseLangLabel: 'Changer la langue du site. La langue actuelle est {{lang}}',
                languages: [
                    {
                        acronym: 'FR',
                        connectTitle: 'Se connecter',
                        href: baseUrl + '/fr/',
                        label: 'Français',
                        language: 'fr',
                        title: 'ARTE en 6 langues',
                    },
                    {
                        acronym: 'DE',
                        connectTitle: 'Einloggen',
                        href: baseUrl + '/de/',
                        label: 'Deutsch',
                        language: 'de',
                        title: 'ARTE in 6 Sprachen',
                    },
                    {
                        acronym: 'EN',
                        connectTitle: 'Log in',
                        href: baseUrl + '/en/',
                        label: 'English',
                        language: 'en',
                        title: 'ARTE in 6 languages',
                    },
                    {
                        acronym: 'ES',
                        connectTitle: 'Conectarse',
                        href: baseUrl + '/es/',
                        label: 'Español',
                        language: 'es',
                        title: 'ARTE en 6 idiomas',
                    },
                    {
                        acronym: 'PL',
                        connectTitle: 'Zaloguj',
                        href: baseUrl + '/pl/',
                        label: 'Polski',
                        language: 'pl',
                        title: 'ARTE w 6 językach',
                    },
                    {
                        acronym: 'IT',
                        connectTitle: 'Connessione',
                        href: baseUrl + '/it/',
                        label: 'Italiano',
                        language: 'it',
                        title: 'ARTE in 6 lingue',
                    },
                ],
            },
            InstallApp: "Installer l'app",
            SearchNavigation: {
                href: baseUrl + '/fr/search/',
                icon: 'arte-next-nav-search',
                label: 'Rechercher un programme',
                closeLabel: 'Masquer et annuler la recherche',
                accessLabel: "Rechercher un programme. Les résultats s'affichent automatiquement. ",
                displayLabel: 'Afficher la recherche',
            },
            MenuNavigation: {
                ariaLabel: 'Menu principal',
                submenuLabel: 'Sous-menu de {{category}}',
                mobileLinks: [
                    {
                        label: 'Accueil',
                        href: baseUrl + '/fr/',
                        id: 'home',
                    },
                    {
                        label: 'Guide TV',
                        href: baseUrl + '/fr/guide/',
                        id: 'guide',
                    },
                    {
                        label: 'Direct',
                        href: baseUrl + '/fr/direct/',
                        id: 'live',
                    },
                    {
                        label: 'Bientôt en ligne',
                        href: baseUrl + '/fr/p/a-venir/',
                        id: 'upcoming',
                    },
                ],
                categories: [
                    {
                        description:
                            "Plutôt investigation ou évasion ? Histoire, sciences, musique ou culture ? Tous nos documentaires et reportages en un coup d'œil.",
                        label: 'Documentaires et reportages',
                        slug: 'documentaires-et-reportages',
                        kind: 'internal',
                        href: 'https://www.arte.tv/fr/videos/documentaires-et-reportages/',
                        deeplink: 'arte://emac/DOR',
                        code: 'DOR',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Cinéma d’auteur, films de patrimoine, muets ou trash, courts métrages : le septième art à l’honneur.',
                        label: 'Cinéma',
                        slug: 'cinema',
                        kind: 'internal',
                        href: baseUrl + '/fr/videos/cinema/',
                        deeplink: 'arte://emac/CIN',
                        code: 'CIN',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Polars, drames psychologiques, comédies ou sagas… Des séries originales et le meilleur des téléfilms européens.',
                        label: 'Séries et fictions',
                        slug: 'series-et-fictions',
                        kind: 'internal',
                        href: baseUrl + '/fr/videos/series-et-fictions/',
                        deeplink: 'arte://emac/SER',
                        code: 'SER',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Décryptages de l’actu internationale, scientifique ou culturelle… Zoom sur les phénomènes de société qui font débat.',
                        label: 'Info et société',
                        slug: 'info-et-societe',
                        kind: 'internal',
                        href: baseUrl + '/fr/videos/info-et-societe/',
                        deeplink: 'arte://emac/ACT',
                        code: 'ACT',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Arts, création contemporaine, culture pop et underground : les grandes tendances et les nouveaux talents.',
                        label: 'Culture et pop',
                        slug: 'culture-et-pop',
                        kind: 'internal',
                        href: baseUrl + '/fr/videos/culture-et-pop/',
                        deeplink: 'arte://emac/CPO',
                        code: 'CPO',
                        icons: [],
                        links: [],
                    },
                    {
                        description: 'Le meilleur du spectacle vivant, toute l’année, comme si vous y étiez !',
                        label: 'ARTE Concert',
                        slug: 'arte-concert',
                        kind: 'internal',
                        href: baseUrl + '/fr/arte-concert/',
                        deeplink: 'arte://emac/ARTE_CONCERT',
                        code: 'ARS',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Médecine, environnement, nouvelles technologies... pour mieux comprendre le monde grâce aux sciences !',
                        label: 'Sciences',
                        slug: 'sciences',
                        kind: 'internal',
                        href: baseUrl + '/fr/videos/sciences/',
                        deeplink: 'arte://emac/SCI',
                        code: 'SCI',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Des images d’exception pour découvrir la nature, les animaux, des pays et des civilisations.',
                        label: 'Voyages et découvertes',
                        slug: 'voyages-et-decouvertes',
                        kind: 'internal',
                        href: baseUrl + '/fr/videos/voyages-et-decouvertes/',
                        deeplink: 'arte://emac/DEC',
                        code: 'DEC',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Les événements des XIXe et XXe siècle et les civilisations anciennes qui ont façonné le monde d’aujourd’hui.',
                        label: 'Histoire',
                        slug: 'histoire',
                        kind: 'internal',
                        href: baseUrl + '/fr/videos/histoire/',
                        deeplink: 'arte://emac/HIS',
                        code: 'HIS',
                        icons: [],
                        links: [],
                    },
                ],
                otherLinks: [
                    {
                        label: 'Les émissions',
                        slug: null,
                        href: baseUrl + '/fr/videos/emissions/',
                        deeplink: 'arte://magazines',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Toutes les vidéos',
                        slug: null,
                        href: baseUrl + '/fr/videos/plus-vues/',
                        deeplink: 'arte://programs/popular',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Audiodescription',
                        slug: null,
                        href: baseUrl + '/fr/videos/programmes-en-audiodescription/',
                        deeplink: 'arte://programs/audiodescription',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Jeux concours',
                        slug: null,
                        href: 'https://my.arte.tv/index.php?lang=fr&page=events',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Les jeux vidéo',
                        slug: null,
                        href: baseUrl + '/digitalproductions/categories/jeux-video/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'ARTE VOD/DVD',
                        slug: null,
                        href: 'http://boutique.arte.tv/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Productions numériques',
                        slug: null,
                        href: baseUrl + '/digitalproductions/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'ARTE Radio',
                        slug: null,
                        href: 'https://arte.app.link/ARTE_Radio/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                ],
            },
            RedirectionAnchor: {
                redirectMainLabel: 'Passer au contenu principal',
                redirectSearchLabel: 'Passer à la recherche',
                redirectPlayerLabel: 'Passer au lecteur vidéo',
            },
            Message: {
                closeLabel: 'Fermer le message',
            },
            SiteMap: {
                title: 'Plan du site',
                general: [
                    {
                        label: 'Accueil',
                        href: baseUrl + '/fr/',
                        id: 'home',
                    },
                    {
                        label: 'Guide TV',
                        href: baseUrl + '/fr/guide/',
                        id: 'guide',
                    },
                    {
                        label: 'Direct',
                        href: baseUrl + '/fr/direct/',
                        id: 'live',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/fr/arte-concert/',
                        id: 'concert',
                    },
                    {
                        label: 'Afficher la recherche',
                        href: baseUrl + '/fr/search/',
                        id: 'search',
                    },
                ],

                categories: [
                    {
                        label: 'Documentaires et reportages',
                        href: 'https://www.arte.tv/fr/videos/documentaires-et-reportages/',
                        id: 'DOR',
                    },
                    {
                        label: 'Cinéma',
                        href: baseUrl + '/fr/videos/cinema/',
                        id: 'CIN',
                    },
                    {
                        label: 'Séries et fictions',
                        href: baseUrl + '/fr/videos/series-et-fictions/',
                        id: 'SER',
                    },
                    {
                        label: 'Info et société',
                        href: baseUrl + '/fr/videos/info-et-societe/',
                        id: 'ACT',
                    },
                    {
                        label: 'Culture et pop',
                        href: baseUrl + '/fr/videos/culture-et-pop/',
                        id: 'CPO',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/fr/arte-concert/',
                        id: 'ARS',
                    },
                    {
                        label: 'Sciences',
                        href: baseUrl + '/fr/videos/sciences/',
                        id: 'SCI',
                    },
                    {
                        label: 'Voyages et découvertes',
                        href: baseUrl + '/fr/videos/voyages-et-decouvertes/',
                        id: 'DEC',
                    },
                    {
                        label: 'Histoire',
                        href: baseUrl + '/fr/videos/histoire/',
                        id: 'HIS',
                    },
                ],
                menuNavigation: [
                    { id: 'tvShows', label: 'Les émissions', href: baseUrl + '/fr/videos/emissions/' },
                    { id: 'allVideos', label: 'Toutes les vidéos', href: baseUrl + '/fr/videos/plus-vues/' },
                    {
                        id: 'audiodescription',
                        label: 'Audiodescription',
                        href: baseUrl + '/fr/videos/programmes-en-audiodescription/',
                    },
                    { id: 'invit', label: 'Invitations', href: 'https://my.arte.tv/index.php?lang=fr&page=events' },
                    {
                        id: 'threesixty',
                        label: 'ARTE 360°',
                        href: baseUrl + '/digitalproductions/categories/jeux-video/',
                    },
                    { id: 'vodDvd', label: 'ARTE VOD/DVD', href: 'https://boutique.arte.tv/' },
                    { id: 'numProduct', label: 'Productions numériques', href: baseUrl + '/digitalproductions/' },
                    { id: 'radio', label: 'ARTE Radio', href: 'https://arte.app.link/ARTE_Radio/' },
                ],
            },
            Settings: {
                title: 'Paramètres',
                href: baseUrl + '/fr/settings/',
            },
        },
        de: {
            Club: {
                home: 'MeinARTE',
                profile: 'Mein Profil ändern',
                login: 'Einloggen',
                logout: 'Abmelden',
                pseudo: 'MeinARTE',
            },
            Concert: {
                title: 'ARTE Concert',
                url: baseUrl + '/de/arte-concert/',
                navigation: {
                    label: 'Menü ARTE Concert',
                    links: [
                        {
                            label: 'Pop',
                            href: baseUrl + '/de/arte-concert/pop/',
                            id: 'concert-modern',
                            kind: 'preference',
                            tracking: {
                                target: null,
                                click_name: 'Modern',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                        {
                            label: 'Klassik',
                            href: baseUrl + '/de/arte-concert/klassik/',
                            id: 'concert-classic',
                            kind: 'preference',
                            tracking: {
                                target: null,
                                click_name: 'Classic',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                        {
                            label: 'Musik entdecken',
                            href: baseUrl + '/de/arte-concert/neueste-videos/ ',
                            id: 'concert-genres',
                            kind: 'other',
                            tracking: {
                                target: null,
                                click_name: 'Parcourir_les_genres',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                        {
                            label: 'Demnächst',
                            href: baseUrl + '/de/arte-concert/demnachst/',
                            id: 'guide',
                            kind: 'other',
                            tracking: {
                                target: null,
                                click_name: 'A_venir',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                    ],
                },
                 socialNetworks:{
                    facebook: 'https://www.facebook.com/ARTEConcertDE',
                    twitter: null,
                    instagram: " https://www.instagram.com/arteconcertde/",
                    youtube: "https://www.youtube.com/c/arteconcert",
                    twitch: "https://www.twitch.tv/artefr?lang=de",
                },
                 concertSelectGenre:{
                    title:{label:"Musik entdecken", href:baseUrl +"/de/arte-concert/neueste-videos/"},
                    items:[
                        {
                            label:"Pop & Rock",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=pop-rock"
                        },
                        {
                            label:"Electronic",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=electronic"
                        },
                        {
                            label:"Hip Hop",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=hip-hop"
                        },
                        {
                            label:"Metal",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=metal"
                        },
                        {
                            label:"Klassik",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=klassik"
                        },
                        {
                            label:"Oper",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=oper"
                        },
                        {
                            label:"Jazz",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=jazz"
                        },
                        {
                            label:"Weltmusik",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=weltmusik"
                        },
                        {
                            label:"Buehnen-Performance",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=buehnen-performance"
                        },
                        {
                            label:"Barockmusik",
                            href:baseUrl +"/de/arte-concert/neueste-videos/?genres=barockmusik"
                        },
                       
                    ]
               
            },
            guide:{  label: 'Demnächst',
                            href: baseUrl + '/de/arte-concert/demnachst/',}
            },
            LogoNavigation: {
                label: '',
                title: 'Arte, home',
                href: baseUrl + '/de/',
            },
            DesktopNavigation: {
                ariaLabel: 'Sekundäre Navigation',
                links: [
                    {
                        label: 'TV-Programm',
                        href: baseUrl + '/de/guide/',
                        id: 'guide',
                    },
                    {
                        label: 'Live',
                        href: baseUrl + '/de/live/',
                        id: 'live',
                    },
                    {
                        label: 'Bald online',
                        href: baseUrl + '/de/p/demnaechst/',
                        id: 'upcoming',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/de/arte-concert/',
                        id: 'concert',
                        color: '#FF8BCA',
                        tracking: {
                            target: null,
                            click_name: 'arte_concert_button',
                            click_type: 'navigation',
                            categories: ['Header'],
                        },
                    },
                ],
            },
            Languages: {
                choseLangLabel: 'Zu einer anderen Sprache wechseln. Die aktuelle Sprache ist {{lang}}',
                languages: [
                    {
                        acronym: 'FR',
                        connectTitle: 'Se connecter',
                        href: baseUrl + '/fr/',
                        label: 'Français',
                        language: 'fr',
                        title: 'ARTE en 6 langues',
                    },
                    {
                        acronym: 'DE',
                        connectTitle: 'Einloggen',
                        href: baseUrl + '/de/',
                        label: 'Deutsch',
                        language: 'de',
                        title: 'ARTE in 6 Sprachen',
                    },
                    {
                        acronym: 'EN',
                        connectTitle: 'Log in',
                        href: baseUrl + '/en/',
                        label: 'English',
                        language: 'en',
                        title: 'ARTE in 6 languages',
                    },
                    {
                        acronym: 'ES',
                        connectTitle: 'Conectarse',
                        href: baseUrl + '/es/',
                        label: 'Español',
                        language: 'es',
                        title: 'ARTE en 6 idiomas',
                    },
                    {
                        acronym: 'PL',
                        connectTitle: 'Zaloguj',
                        href: baseUrl + '/pl/',
                        label: 'Polski',
                        language: 'pl',
                        title: 'ARTE w 6 językach',
                    },
                    {
                        acronym: 'IT',
                        connectTitle: 'Connessione',
                        href: baseUrl + '/it/',
                        label: 'Italiano',
                        language: 'it',
                        title: 'ARTE in 6 lingue',
                    },
                ],
            },
            InstallApp: 'App installieren',
            SearchNavigation: {
                href: baseUrl + '/de/search/',
                icon: 'arte-next-nav-search',
                label: 'Die Suche anzeigen',
            },
            MenuNavigation: {
                ariaLabel: 'Hauptnavigation',
                submenuLabel: 'Subnavigation von {{category}}',
                mobileLinks: [
                    {
                        label: 'Home',
                        href: baseUrl + '/de/',
                    },
                    {
                        label: 'TV-Programm',
                        href: baseUrl + '/de/guide/',
                    },
                    {
                        label: 'Live',
                        href: baseUrl + '/de/live/',
                    },
                    {
                        label: 'Bald online',
                        href: baseUrl + '/de/p/demnaechst/',
                        id: 'upcoming',
                    },
                ],
                categories: [
                    {
                        description:
                            'Von Geschichte über Wissenschaft bis hin zu Kultur – alle Dokumentationen und Reportagen im Überblick.',
                        label: 'Dokus und Reportagen',
                        slug: 'dokumentationen-und-reportagen',
                        kind: 'internal',
                        href: 'https://www.arte.tv/de/videos/dokumentationen-und-reportagen/',
                        deeplink: 'arte://emac/DOR',
                        code: 'DOR',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Ob Meisterwerk der Filmgeschichte, Kurzfilm oder Trash – ARTE ehrt das Filmgenre in all seinen Facetten.',
                        label: 'Kino',
                        slug: 'kino',
                        kind: 'internal',
                        href: baseUrl + '/de/videos/kino/',
                        deeplink: 'arte://emac/CIN',
                        code: 'CIN',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Ob Krimis, Familiendramen, Komödien oder historische Stoffe – fesselnde Fernsehfilme und Serien auf ARTE',
                        label: 'Fernsehfilme und Serien',
                        slug: 'fernsehfilme-und-serien',
                        kind: 'internal',
                        href: baseUrl + '/de/videos/fernsehfilme-und-serien/',
                        deeplink: 'arte://emac/SER',
                        code: 'SER',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Investigative Dokumentarfilme und Magazine, geopolitische Analysen, Berichte über das tagesaktuelle Geschehen, neue Trends aus Wissenschaft, Technik und Medizin – ARTE untersucht die Herausforderungen unserer Zeit.',
                        label: 'Aktuelles und Gesellschaft',
                        slug: 'aktuelles-und-gesellschaft',
                        kind: 'internal',
                        href: baseUrl + '/de/videos/aktuelles-und-gesellschaft/',
                        deeplink: 'arte://emac/ACT',
                        code: 'ACT',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Kunst, Popkultur und Underground: das Beste der europäischen und internationalen Kulturszene.',
                        label: 'Kultur und Pop',
                        slug: 'kultur-und-pop',
                        kind: 'internal',
                        href: baseUrl + '/de/videos/kultur-und-pop/',
                        deeplink: 'arte://emac/CPO',
                        code: 'CPO',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Das Beste aus Musik und Bühnenkunst: Tauchen Sie ein, als ob Sie selbst dabei wären!',
                        label: 'ARTE Concert',
                        slug: 'arte-concert',
                        kind: 'internal',
                        href: baseUrl + '/de/arte-concert/',
                        deeplink: 'arte://emac/ARTE_CONCERT',
                        code: 'ARS',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Forschung rund um Medizin, Umwelt, neue Technologien – Einblicke in innovative Zukunftslabore',
                        label: 'Wissenschaft',
                        slug: 'wissenschaft',
                        kind: 'internal',
                        href: baseUrl + '/de/videos/wissenschaft/',
                        deeplink: 'arte://emac/SCI',
                        code: 'SCI',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Spannende Entdeckungsreisen ins Reich der Tiere, in die Natur und durch ferne Länder und Kulturen.',
                        label: 'Entdeckung der Welt',
                        slug: 'entdeckung-der-welt',
                        kind: 'internal',
                        href: baseUrl + '/de/videos/entdeckung-der-welt/',
                        deeplink: 'arte://emac/DEC',
                        code: 'DEC',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Historische Ereignisse des 19. und 20. Jahrhunderts und antike Zivilisationen, die die Menschheit geprägt haben.',
                        label: 'Geschichte',
                        slug: 'geschichte',
                        kind: 'internal',
                        href: baseUrl + '/de/videos/geschichte/',
                        deeplink: 'arte://emac/HIS',
                        code: 'HIS',
                        icons: [],
                        links: [],
                    },
                ],
                otherLinks: [
                    {
                        label: 'Alle Sendungen',
                        slug: null,
                        href: baseUrl + '/de/videos/sendungen/',
                        deeplink: 'arte://magazines',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Alle Videos',
                        slug: null,
                        href: baseUrl + '/de/videos/meistgesehen/',
                        deeplink: 'arte://programs/popular',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Audiodeskription',
                        slug: null,
                        href: baseUrl + '/de/videos/programme-mit-audiodeskription/',
                        deeplink: 'arte://programs/audiodescription',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Gewinnspiele',
                        slug: null,
                        href: 'https://my.arte.tv/index.php?lang=de&page=events',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Videospiele',
                        slug: null,
                        href: baseUrl + '/digitalproductions/de/categories/videospiele/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'ARTE Magazin',
                        slug: null,
                        href: 'https://www.arte-magazin.de/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'ARTE Edition',
                        slug: null,
                        href: 'http://www.arte-edition.de/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Digitale Produktionen',
                        slug: null,
                        href: baseUrl + '/digitalproductions/de/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                ],
            },
            RedirectionAnchor: {
                redirectMainLabel: 'Zum Hauptinhalt',
                redirectSearchLabel: 'Zur Suche',
                redirectPlayerLabel: 'Zum Video-Player',
            },
            Message: {
                closeLabel: 'Nachricht Schließen',
            },
            SiteMap: {
                title: 'Seitenübersicht',

                general: [
                    {
                        label: 'Home',
                        href: baseUrl + '/de/',
                        id: 'home',
                    },
                    {
                        label: 'TV-Programm',
                        href: baseUrl + '/de/guide/',
                        id: 'guide',
                    },
                    {
                        label: 'Live',
                        href: baseUrl + '/de/live/',
                        id: 'live',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/de/arte-concert/',
                        id: 'concert',
                    },
                    {
                        label: 'Die Suche anzeigen',
                        href: baseUrl + '/de/search/',
                        id: 'search',
                    },
                ],

                categories: [
                    {
                        label: 'Dokus und Reportagen',
                        href: 'https://www.arte.tv/de/videos/dokumentationen-und-reportagen/',
                        id: 'DOR',
                    },
                    {
                        label: 'Kino',
                        href: baseUrl + '/de/videos/kino/',
                        id: 'CIN',
                    },
                    {
                        label: 'Fernsehfilme und Serien',
                        href: baseUrl + '/de/videos/fernsehfilme-und-serien/',
                        id: 'SER',
                    },
                    {
                        label: 'Aktuelles und Gesellschaft',
                        href: baseUrl + '/de/videos/aktuelles-und-gesellschaft/',
                        id: 'ACT',
                    },
                    {
                        label: 'Kultur und Pop',
                        href: baseUrl + '/de/videos/kultur-und-pop/',
                        id: 'CPO',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/de/arte-concert/',
                        id: 'ARS',
                    },
                    {
                        label: 'Wissenschaft',
                        href: baseUrl + '/de/videos/wissenschaft/',
                        id: 'SCI',
                    },
                    {
                        label: 'Entdeckung der Welt',
                        href: baseUrl + '/de/videos/entdeckung-der-welt/',
                        id: 'DEC',
                    },
                    {
                        label: 'Geschichte',
                        href: baseUrl + '/de/videos/geschichte/',
                        id: 'HIS',
                    },
                ],
                menuNavigation: [
                    { id: 'tvShows', label: 'Alle Sendungen', href: baseUrl + '/de/videos/sendungen/' },
                    { id: 'allVideos', label: 'Alle Videos', href: baseUrl + '/de/videos/meistgesehen/' },
                    {
                        id: 'audiodescription',
                        label: 'Audiodescription',
                        href: baseUrl + '/de/videos/programme-mit-audiodeskription/',
                    },
                    { id: 'invit', label: 'Gästeliste', href: 'https://my.arte.tv/index.php?lang=de&page=events' },
                    {
                        id: 'threesixty',
                        label: 'ARTE 360°',
                        href: baseUrl + '/digitalproductions/de/categories/jeux-video/',
                    },
                    { id: 'magazin', label: 'ARTE Magazin', href: 'https://www.arte-magazin.de/' },
                    { id: 'edition', label: 'ARTE Edition', href: 'https://www.arte-edition.de/cat/' },
                    { id: 'numProduct', label: 'Digitale Produktionen', href: baseUrl + '/digitalproductions/de/' },
                ],
            },
            Settings: {
                title: 'Die Einstellungen',
                href: baseUrl + '/de/settings/',
            },
        },
        en: {
            Club: {
                home: 'Login to MyARTE',
                profile: 'Change my profile',
                login: 'Login',
                logout: 'Log out',
                pseudo: 'MyARTE',
            },
            Concert: {
                title: 'ARTE Concert',
                url: baseUrl + '/en/arte-concert/',
                navigation: {
                    label: 'ARTE Concert menu',
                    links: [
                        {
                            label: 'Search genres',
                            href: baseUrl + '/en/arte-concert/most-recent/',
                            id: 'concert-genres',
                            kind: 'other',
                            tracking: {
                                target: null,
                                click_name: 'Parcourir_les_genres',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                    ],
                },
                 socialNetworks:{
                    facebook: null,
                    twitter: null,
                    instagram: null,
                    youtube: null,
                    twitch: null,
                },
                       concertSelectGenre:{
                    title:{label:"Search genres", href:baseUrl +"/en/arte-concert/most-recent/"},
                    items:[
                        {
                            label:"Pop & Rock",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=pop-rock"
                        },
                        {
                            label:"Electronic",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=electronic"
                        },
                        {
                            label:"Hip-hop",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=hip-hop"
                        },
                        {
                            label:"Metal",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=metal"
                        },
                        {
                            label:"Classical",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=classical"
                        },
                        {
                            label:"Opera",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=opera"
                        },
                        {
                            label:"Jazz",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=jazz"
                        },
                        {
                            label:"World music",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=world-music"
                        },
                        {
                            label:"Performing arts",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=performing-arts"
                        },
                        {
                            label:"Baroque",
                            href:baseUrl +"/en/arte-concert/most-recent/?genres=baroque"
                        },
                       
                    ]
               
            },
              guide:null,
            },
            DesktopNavigation: {
                ariaLabel: 'Submenu',
                links: [
                    {
                        label: 'Search',
                        href: baseUrl + '/en/search/',
                        id: 'search',
                    },
                    {
                        label: 'About',
                        href: baseUrl + '/sites/en/corporate/what-we-do/',
                        id: 'about',
                    },
                ],
            },
            MenuNavigation: {
                ariaLabel: 'Main Menu',
                submenuLabel: '{{category}} submenu',
                mobileLinks: [
                    {
                        label: 'Home',
                        href: baseUrl + '/en/',
                    },
                    {
                        label: 'Search',
                        href: baseUrl + '/en/search/',
                        id: 'search',
                    },
                    {
                        label: 'About',
                        href: baseUrl + '/sites/en/corporate/what-we-do/',
                        id: 'about',
                    },
                ],
                categories: [
                    {
                        description:
                            'Investigative documentary series, geopolitical analysis, and international commentary',
                        label: 'Politics and society',
                        slug: 'politics-and-society',
                        kind: 'internal',
                        href: baseUrl + '/en/videos/politics-and-society/',
                        deeplink: 'arte://emac/ACT',
                        code: 'ACT',
                        icons: [],
                        links: [],
                    },
                    {
                        description: '',
                        label: 'Cinema',
                        slug: 'cinema',
                        kind: 'internal',
                        href: baseUrl + '/en/videos/cinema/',
                        deeplink: 'arte://emac/CIN',
                        code: 'CIN',
                        icons: [],
                        links: [],
                    },
                    {
                        description: '',
                        label: 'Series',
                        slug: 'series',
                        kind: 'internal',
                        href: baseUrl + '/en/videos/series/',
                        deeplink: 'arte://emac/SER',
                        code: 'SER',
                        icons: [],
                        links: [],
                    },
                    {
                        description: 'The best of culture: theatre, dance, painting, architecture, and more.',
                        label: 'Culture',
                        slug: 'culture',
                        kind: 'internal',
                        href: baseUrl + '/en/videos/culture/',
                        deeplink: 'arte://emac/CPO',
                        code: 'CPO',
                        icons: [],
                        links: [],
                    },
                    {
                        description: 'The best performances, including world music, classical and dance. ',
                        label: 'ARTE Concert',
                        slug: 'arte-concert',
                        kind: 'internal',
                        href: baseUrl + '/en/arte-concert/',
                        deeplink: 'arte://emac/ARTE_CONCERT',
                        code: 'ARS',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Your key to understanding the latest breakthroughs in medical and environmental science.',
                        label: 'Sciences',
                        slug: 'sciences',
                        kind: 'internal',
                        href: baseUrl + '/en/videos/sciences/',
                        deeplink: 'arte://emac/SCI',
                        code: 'SCI',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Discover all that science and nature has to offer with exceptional cinematography.',
                        label: 'Discovery',
                        slug: 'discovery',
                        kind: 'internal',
                        href: baseUrl + '/en/videos/discovery/',
                        deeplink: 'arte://emac/DEC',
                        code: 'DEC',
                        icons: [],
                        links: [],
                    },
                    {
                        description: 'The major historical events and civilisations that shaped the world',
                        label: 'History',
                        slug: 'history',
                        kind: 'internal',
                        href: baseUrl + '/en/videos/history/',
                        deeplink: 'arte://emac/HIS',
                        code: 'HIS',
                        icons: [],
                        links: [],
                    },
                ],
                otherLinks: [
                    {
                        label: 'Magazine Shows',
                        slug: null,
                        href: baseUrl + '/en/videos/magazine-shows/',
                        deeplink: null,
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'All programmes',
                        slug: null,
                        href: baseUrl + '/en/videos/most-viewed/',
                        deeplink: 'arte://programs/popular',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Video Games',
                        slug: null,
                        href: baseUrl + '/digitalproductions/en/categories/video-games/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Digital Productions',
                        slug: null,
                        href: baseUrl + '/digitalproductions/en/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                ],
            },
            LogoNavigation: {
                label: 'in English',
                title: 'Arte in English',
                href: baseUrl + '/en/',
                links: [
                    {
                        label: 'ARTE Concert',
                        color: '#FF8BCA',
                        id: 'concert',
                        href: baseUrl + '/en/arte-concert/',
                    },
                    {
                        label: 'About',
                        href: baseUrl + '/sites/en/corporate/what-we-do/',
                        id: 'about',
                    },
                ],
            },
            Languages: {
                choseLangLabel: 'Change the language. The current language is {{lang}}',
                languages: [
                    {
                        acronym: 'FR',
                        connectTitle: 'Se connecter',
                        href: baseUrl + '/fr/',
                        label: 'Français',
                        language: 'fr',
                        title: 'ARTE en 6 langues',
                    },
                    {
                        acronym: 'DE',
                        connectTitle: 'Einloggen',
                        href: baseUrl + '/de/',
                        label: 'Deutsch',
                        language: 'de',
                        title: 'ARTE in 6 Sprachen',
                    },
                    {
                        acronym: 'EN',
                        connectTitle: 'Log in',
                        href: baseUrl + '/en/',
                        label: 'English',
                        language: 'en',
                        title: 'ARTE in 6 languages',
                    },
                    {
                        acronym: 'ES',
                        connectTitle: 'Conectarse',
                        href: baseUrl + '/es/',
                        label: 'Español',
                        language: 'es',
                        title: 'ARTE en 6 idiomas',
                    },
                    {
                        acronym: 'PL',
                        connectTitle: 'Zaloguj',
                        href: baseUrl + '/pl/',
                        label: 'Polski',
                        language: 'pl',
                        title: 'ARTE w 6 językach',
                    },
                    {
                        acronym: 'IT',
                        connectTitle: 'Connessione',
                        href: baseUrl + '/it/',
                        label: 'Italiano',
                        language: 'it',
                        title: 'ARTE in 6 lingue',
                    },
                ],
            },
            InstallApp: 'Install the app',
            RedirectionAnchor: {
                redirectMainLabel: 'Go to the main content',
                redirectSearchLabel: 'Go to search',
                redirectPlayerLabel: 'Go to video player',
            },
            Message: {
                closeLabel: 'Close the message',
            },
            SearchNavigation: {
                label: 'Show the search bar',
                href: baseUrl + '/en/search/',
                icon: 'arte-next-nav-search',
            },
            SiteMap: {
                title: 'Site map',
                general: [
                    {
                        label: 'Home',
                        href: baseUrl + '/en/',
                        id: 'home',
                    },

                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/en/arte-concert/',
                        id: 'concert',
                    },
                    {
                        label: 'Show the search bar',
                        href: baseUrl + '/en/search/',
                        id: 'search',
                    },
                ],

                categories: [
                    {
                        label: 'Politics and society',
                        href: baseUrl + '/en/videos/politics-and-society/',
                        id: 'ACT',
                    },
                    {
                        label: 'Culture',
                        href: baseUrl + '/en/videos/culture/',
                        id: 'CPO',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/en/arte-concert/',
                        id: 'ARS',
                    },
                    {
                        label: 'Sciences',
                        href: baseUrl + '/en/videos/sciences/',
                        id: 'SCI',
                    },
                    {
                        label: 'Discovery',
                        href: baseUrl + '/en/videos/discovery/',
                        id: 'DEC',
                    },
                    {
                        label: 'History',
                        href: baseUrl + '/en/videos/history/',
                        id: 'HIS',
                    },
                ],
                menuNavigation: [
                    { id: 'tvShows', label: 'Magazine Shows', href: baseUrl + '/en/videos/magazine-shows/' },
                    { id: 'allVideos', label: 'All programmes', href: baseUrl + '/en/videos/most-viewed/' },

                    { id: 'numProduct', label: 'Digital Productions', href: baseUrl + 'digitalproductions/en/' },
                    { id: 'about', label: 'About', href: baseUrl + '/sites/corporate/en/what-we-do/' },
                ],
            },
            Settings: {
                title: 'Settings',
                href: baseUrl + '/en/settings/',
            },
        },
        es: {
            Club: {
                home: 'Acceder a MiARTE',
                profile: 'Modificar mi perfil',
                login: 'Conectarse',
                logout: 'Desconectarme',
                pseudo: 'MiARTE',
            },
            Concert: {
                title: 'ARTE Concert',
                url: baseUrl + '/es/arte-concert/',
                navigation: {
                    label: 'Menu ARTE Concert',
                    links: [
                        {
                            label: 'Recorrer los géneros',
                            href: baseUrl + '/es/arte-concert/los-mas-recientes/',
                            id: 'concert-genres',
                            kind: 'other',
                            tracking: {
                                target: null,
                                click_name: 'Parcourir_les_genres',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                    ],
                },
                socialNetworks:{
                    facebook: null,
                    twitter: null,
                    instagram: null,
                    youtube: null,
                    twitch: null,
                },
                       concertSelectGenre:{
                    title:{label:"Recorrer los géneros", href:baseUrl +"/es/arte-concert/los-mas-recientes/"},
                    items:[
                        {
                            label:"Pop y rock",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=pop-y-rock"
                        },
                        {
                            label:"Música electrónica",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=musica-electronica"
                        },
                        {
                            label:"Hip-hop",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=hip-hop"
                        },
                        {
                            label:"Metal",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=metal"
                        },
                        {
                            label:"Clásica",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=clasica"
                        },
                        {
                            label:"Ópera",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=opera"
                        },
                        {
                            label:"Jazz",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=jazz"
                        },
                        {
                            label:"Músicas del mundo",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=musicas-del-mundo"
                        },
                        {
                            label:"Artes escénicas",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=artes-escenicas"
                        },
                        {
                            label:"Música barroca",
                            href:baseUrl +"/es/arte-concert/los-mas-recientes/?genres=musica-barroca"
                        },
                       
                    ]
               
            },
               guide:null,
            },
            DesktopNavigation: {
                ariaLabel: 'Menú secundario',
                links: [
                    {
                        label: 'Búsqueda',
                        href: baseUrl + '/es/search/',
                        id: 'search',
                    },
                    {
                        label: 'Quiénes somos',
                        href: baseUrl + '/sites/es/corporate/que-hacemos/',
                        id: 'about',
                    },
                ],
            },
            MenuNavigation: {
                ariaLabel: 'Menú principal',
                submenuLabel: 'Subcategorías de {{category}}',
                mobileLinks: [
                    {
                        label: 'Inicio',
                        href: baseUrl + '/es/',
                    },
                    {
                        label: 'Búsqueda',
                        href: baseUrl + '/es/search/',
                        id: 'search',
                    },
                    {
                        label: 'Quiénes somos',
                        href: baseUrl + '/sites/es/corporate/que-hacemos/',
                        id: 'about',
                    },
                ],
                categories: [
                    {
                        description:
                            'Análisis de la actualidad internacional, científica y cultural, y de los fenómenos sociales que generan debate',
                        label: 'Política y sociedad',
                        slug: 'politica-y-sociedad',
                        kind: 'internal',
                        href: baseUrl + '/es/videos/politica-y-sociedad/',
                        deeplink: 'arte://emac/ACT',
                        code: 'ACT',
                        icons: [],
                        links: [],
                    },
                    {
                        description: '',
                        label: 'Cine',
                        slug: 'cine',
                        kind: 'internal',
                        href: baseUrl + '/es/videos/cine/',
                        deeplink: 'arte://emac/CIN',
                        code: 'CIN',
                        icons: [],
                        links: [],
                    },
                    {
                        description: '',
                        label: 'Series',
                        slug: 'series-y-ficciones',
                        kind: 'internal',
                        href: baseUrl + '/es/videos/series-y-ficciones/',
                        deeplink: 'arte://emac/SER',
                        code: 'SER',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Lo mejor de la creación contemporánea internacional, de la cultura pop y de la escena alternativa.',
                        label: 'Cultura y pop',
                        slug: 'cultura-y-pop',
                        kind: 'internal',
                        href: baseUrl + '/es/videos/cultura-y-pop/',
                        deeplink: 'arte://emac/CPO',
                        code: 'CPO',
                        icons: [],
                        links: [],
                    },
                    {
                        description: 'Lo mejor del espectáculo en vivo durante todo el año. ¡Como si estuvieses allí! ',
                        label: 'ARTE Concert',
                        slug: 'arte-concert',
                        kind: 'internal',
                        href: baseUrl + '/es/arte-concert/',
                        deeplink: 'arte://emac/ARTE_CONCERT',
                        code: 'ARS',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Los últimos avances científicos en la medicina, el medio ambiente y las nuevas tecnologías. ',
                        label: 'Ciencias',
                        slug: 'ciencias',
                        kind: 'internal',
                        href: baseUrl + '/es/videos/ciencias/',
                        deeplink: 'arte://emac/SCI',
                        code: 'SCI',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Imágenes excepcionales de la naturaleza, de otros lugares y de otras civilizaciones.',
                        label: 'Saber y exploración',
                        slug: 'saber-y-exploracion',
                        kind: 'internal',
                        href: baseUrl + '/es/videos/saber-y-exploracion/',
                        deeplink: 'arte://emac/DEC',
                        code: 'DEC',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Los acontecimientos históricos y los descubrimientos que han dado forma al mundo actual.',
                        label: 'Historia',
                        slug: 'historia',
                        kind: 'internal',
                        href: baseUrl + '/es/videos/historia/',
                        deeplink: 'arte://emac/HIS',
                        code: 'HIS',
                        icons: [],
                        links: [],
                    },
                ],
                otherLinks: [
                    {
                        label: 'Emisiones',
                        slug: null,
                        href: baseUrl + '/es/videos/emisiones/',
                        deeplink: null,
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Videojuego',
                        slug: null,
                        href: baseUrl + '/digitalproductions/es/categories/videojuego/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Todos los vídeos',
                        slug: null,
                        href: baseUrl + '/es/videos/mas-vistos/',
                        deeplink: 'arte://programs/popular',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Producciones digitales',
                        slug: null,
                        href: baseUrl + '/digitalproductions/es/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                ],
            },
            LogoNavigation: {
                label: 'en español',
                title: 'Arte en español',
                href: baseUrl + '/es/',
                links: [
                    {
                        label: 'ARTE Concert',
                        color: '#FF8BCA',
                        id: 'concert',
                        href: baseUrl + '/es/arte-concert/',
                    },
                    {
                        label: 'Quiénes somos',
                        href: baseUrl + '/sites/es/corporate/que-hacemos/',
                        id: 'about',
                    },
                ],
            },
            Languages: {
                choseLangLabel: 'Cambiar de idioma. El actual es {{lang}}',
                languages: [
                    {
                        acronym: 'FR',
                        connectTitle: 'Se connecter',
                        href: baseUrl + '/fr/',
                        label: 'Français',
                        language: 'fr',
                        title: 'ARTE en 6 langues',
                    },
                    {
                        acronym: 'DE',
                        connectTitle: 'Einloggen',
                        href: baseUrl + '/de/',
                        label: 'Deutsch',
                        language: 'de',
                        title: 'ARTE in 6 Sprachen',
                    },
                    {
                        acronym: 'EN',
                        connectTitle: 'Log in',
                        href: baseUrl + '/en/',
                        label: 'English',
                        language: 'en',
                        title: 'ARTE in 6 languages',
                    },
                    {
                        acronym: 'ES',
                        connectTitle: 'Conectarse',
                        href: baseUrl + '/es/',
                        label: 'Español',
                        language: 'es',
                        title: 'ARTE en 6 idiomas',
                    },
                    {
                        acronym: 'PL',
                        connectTitle: 'Zaloguj',
                        href: baseUrl + '/pl/',
                        label: 'Polski',
                        language: 'pl',
                        title: 'ARTE w 6 językach',
                    },
                    {
                        acronym: 'IT',
                        connectTitle: 'Connessione',
                        href: baseUrl + '/it/',
                        label: 'Italiano',
                        language: 'it',
                        title: 'ARTE in 6 lingue',
                    },
                ],
            },
            InstallApp: 'Instalar la app',
            RedirectionAnchor: {
                redirectMainLabel: 'Ir al contenido principal',
                redirectSearchLabel: 'Ir a la búsqueda',
                redirectPlayerLabel: 'Vai al player video',
            },
            Message: {
                closeLabel: 'Cierra el mensaje',
            },
            SearchNavigation: {
                label: 'Mostrar la búsqueda',
                href: baseUrl + '/es/search/',
                icon: 'arte-next-nav-search',
            },
            SiteMap: {
                title: 'Mapa web',
                general: [
                    {
                        label: 'Home',
                        href: baseUrl + '/es/',
                        id: 'home',
                    },

                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/es/arte-concert/',
                        id: 'concert',
                    },
                    {
                        label: 'Mostrar la búsqueda',
                        href: baseUrl + '/es/search/',
                        id: 'search',
                    },
                ],

                categories: [
                    {
                        label: 'Política y sociedad',
                        href: baseUrl + '/es/videos/politica-y-sociedad/',
                        id: 'ACT',
                    },
                    {
                        label: 'Cultura y pop',
                        href: baseUrl + '/es/videos/cultura-y-pop/',
                        id: 'CPO',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/es/arte-concert/',
                        id: 'ARS',
                    },
                    {
                        label: 'Ciencias',
                        href: baseUrl + '/es/videos/ciencias/',
                        id: 'SCI',
                    },
                    {
                        label: 'Saber y exploración',
                        href: baseUrl + '/es/videos/saber-y-exploracion/',
                        id: 'DEC',
                    },
                    {
                        label: 'Historia',
                        href: baseUrl + '/es/videos/historia/',
                        id: 'HIS',
                    },
                ],
                menuNavigation: [
                    { id: 'tvShows', label: 'Emisiones de A a Z', href: baseUrl + '/es/videos/emisiones/' },
                    { id: 'allVideos', label: 'Todos los vídeos', href: baseUrl + '/es/videos/mas-vistos/' },

                    { id: 'about', label: 'Quiénes somos', href: baseUrl + '/sites/corporate/es/que-hacemos/' },
                ],
            },
            Settings: {
                title: 'Ajustes',
                href: baseUrl + '/es/settings/',
            },
        },
        pl: {
            Club: {
                home: 'Dostęp do MojeARTE',
                profile: 'Edytuj profil',
                login: 'Zaloguj',
                logout: 'Wyloguj',
                pseudo: 'MojeARTE',
            },
            Concert: {
                title: 'ARTE Concert',
                url: baseUrl + '/pl/arte-concert/',
                navigation: {
                    label: 'Menu ARTE Concert',
                    links: [
                        {
                            label: 'Wszystkie gatunki',
                            href: baseUrl + '/pl/arte-concert/najnowsze/ ',
                            id: 'concert-genres',
                            kind: 'other',
                            tracking: {
                                target: null,
                                click_name: 'Parcourir_les_genres',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                    ],
                },
                socialNetworks:{
                    facebook: null,
                    twitter: null,
                    instagram: null,
                    youtube: null,
                    twitch: null,
                },
                   concertSelectGenre:{
                    title:{label:"Wszystkie gatunki", href:baseUrl +"/pl/arte-concert/najnowsze/"},
                    items:[
                        {
                            label:"Pop i rock",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=pop-i-rock"
                        },
                        {
                            label:"Muzyka elektroniczna",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=muzyka-elektroniczna"
                        },
                        {
                            label:"Hip-hop",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=hip-hop"
                        },
                        {
                            label:"Metal",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=metal"
                        },
                        {
                            label:"Muzyka klasyczna",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=muzyka-klasyczna"
                        },
                        {
                            label:"Opera",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=opera"
                        },
                        {
                            label:"Jazz",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=jazz"
                        },
                        {
                            label:"Muzyka z całego świata",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=muzyka-z-calego-swiata"
                        },
                        {
                            label:"Występy sceniczne",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=wystepy-sceniczne"
                        },
                        {
                            label:"Muzyka barokowa",
                            href:baseUrl +"/pl/arte-concert/najnowsze/?genres=muzyka-barokowa"
                        },
                       
                    ]
               
            },
               guide:null,
            },
            DesktopNavigation: {
                ariaLabel: 'Menu dodatkowe',
                links: [
                    {
                        label: 'Wyszukiwanie',
                        href: baseUrl + '/pl/search/',
                        id: 'search',
                    },
                    {
                        label: 'O nas',
                        href: baseUrl + '/sites/pl/corporate/nasza-dzialalnosc/?lang=pl',
                        id: 'about',
                    },
                ],
            },
            MenuNavigation: {
                ariaLabel: 'Menu główne',
                submenuLabel: 'Podkategorie dla {{category}}',
                mobileLinks: [
                    {
                        label: 'Strona główna',
                        href: baseUrl + '/pl/',
                    },
                    {
                        label: 'Wyszukiwanie',
                        href: baseUrl + '/pl/search/',
                        id: 'search',
                    },
                    {
                        label: 'O nas',
                        href: baseUrl + '/sites/pl/corporate/nasza-dzialalnosc/?lang=pl',
                        id: 'about',
                    },
                ],
                categories: [
                    {
                        description:
                            'Dokumenty, reportaże śledcze, analizy geopolityczne, i ocena sytuacji na arenie międzynarodowej. ',
                        label: 'Polityka i społeczeństwo',
                        slug: 'polityka-i-spoleczenstwo',
                        kind: 'internal',
                        href: baseUrl + '/pl/videos/polityka-i-spoleczenstwo/',
                        deeplink: 'arte://emac/ACT',
                        code: 'ACT',
                        icons: [],
                        links: [],
                    },
                    {
                        description: '',
                        label: 'Kino',
                        slug: 'kino',
                        kind: 'internal',
                        href: baseUrl + '/pl/videos/kino/',
                        deeplink: 'arte://emac/CIN',
                        code: 'CIN',
                        icons: [],
                        links: [],
                    },
                    {
                        description: '',
                        label: 'Seriale',
                        slug: 'seriale-i-filmy-fabularne',
                        kind: 'internal',
                        href: baseUrl + '/pl/videos/seriale-i-filmy-fabularne/',
                        deeplink: 'arte://emac/SER',
                        code: 'SER',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'To, co najlepsze w kulturze: teatr, taniec, malarstwo, architektura i najwięksi artyści.',
                        label: 'Kultura',
                        slug: 'kultura',
                        kind: 'internal',
                        href: baseUrl + '/pl/videos/kultura/',
                        deeplink: 'arte://emac/CPO',
                        code: 'CPO',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Najlepsze występy dostępne przez cały rok sprawią że poczujecie jakbyście naprawdę tam byli!',
                        label: 'ARTE Concert',
                        slug: 'arte-concert',
                        kind: 'internal',
                        href: baseUrl + '/pl/arte-concert/',
                        deeplink: 'arte://emac/ARTE_CONCERT',
                        code: 'ARS',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Programy, które pozwolą Wam zrozumieć najnowsze odkrycia w dziedzinie medycy, środowiska i nowych technologii.',
                        label: 'Nauka',
                        slug: 'nauka',
                        kind: 'internal',
                        href: baseUrl + '/pl/videos/nauka/',
                        deeplink: 'arte://emac/SCI',
                        code: 'SCI',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Seriale dokumentalne, reportaże i magazyny naukowe w wyjątkowych ujęciach przedstawiające naturę i ciekawe cywilizacje.',
                        label: 'Odkrycia',
                        slug: 'odkrycia',
                        kind: 'internal',
                        href: baseUrl + '/pl/videos/odkrycia/',
                        deeplink: 'arte://emac/DEC',
                        code: 'DEC',
                        icons: [],
                        links: [],
                    },
                    {
                        description: 'Najważniejsze wydarzenia historyczne, które ukształtowały współczesny świat.',
                        label: 'Historia',
                        slug: 'historia',
                        kind: 'internal',
                        href: baseUrl + '/pl/videos/historia/',
                        deeplink: 'arte://emac/HIS',
                        code: 'HIS',
                        icons: [],
                        links: [],
                    },
                ],
                otherLinks: [
                    {
                        label: 'Magazyny',
                        slug: null,
                        href: baseUrl + '/pl/videos/magazyny/',
                        deeplink: null,
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Gry wideo',
                        slug: null,
                        href: baseUrl + '/digitalproductions/pl/categories/gry-wideo/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Wszystkie programy',
                        slug: null,
                        href: baseUrl + '/pl/videos/najczesciej-ogladane/',
                        deeplink: 'arte://programs/popular',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Produkcje cyfrowe',
                        slug: null,
                        href: baseUrl + 'digitalproductions/pl/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                ],
            },
            LogoNavigation: {
                label: 'po polsku',
                title: 'Arte po polsku',
                href: baseUrl + '/pl/',
                links: [
                    {
                        label: 'ARTE Concert',
                        color: '#FF8BCA',
                        id: 'concert',
                        href: baseUrl + '/pl/arte-concert/',
                    },
                    {
                        label: 'O nas',
                        href: baseUrl + '/sites/pl/corporate/nasza-dzialalnosc/?lang=pl',
                        id: 'about',
                    },
                ],
                
            },
            Languages: {
                choseLangLabel: 'Zmień język. Obecny język to {{lang}}',
                languages: [
                    {
                        acronym: 'FR',
                        connectTitle: 'Se connecter',
                        href: baseUrl + '/fr/',
                        label: 'Français',
                        language: 'fr',
                        title: 'ARTE en 6 langues',
                    },
                    {
                        acronym: 'DE',
                        connectTitle: 'Einloggen',
                        href: baseUrl + '/de/',
                        label: 'Deutsch',
                        language: 'de',
                        title: 'ARTE in 6 Sprachen',
                    },
                    {
                        acronym: 'EN',
                        connectTitle: 'Log in',
                        href: baseUrl + '/en/',
                        label: 'English',
                        language: 'en',
                        title: 'ARTE in 6 languages',
                    },
                    {
                        acronym: 'ES',
                        connectTitle: 'Conectarse',
                        href: baseUrl + '/es/',
                        label: 'Español',
                        language: 'es',
                        title: 'ARTE en 6 idiomas',
                    },
                    {
                        acronym: 'PL',
                        connectTitle: 'Zaloguj',
                        href: baseUrl + '/pl/',
                        label: 'Polski',
                        language: 'pl',
                        title: 'ARTE w 6 językach',
                    },
                    {
                        acronym: 'IT',
                        connectTitle: 'Connessione',
                        href: baseUrl + '/it/',
                        label: 'Italiano',
                        language: 'it',
                        title: 'ARTE in 6 lingue',
                    },
                ],
            },
            InstallApp: "Zainstaluj aplikację",
            RedirectionAnchor: {
                redirectMainLabel: 'Przejdź do części głównej',
                redirectSearchLabel: 'Przejdź do wyszukiwania',
                redirectPlayerLabel: 'Przejdź do odtwarzacza wideo',
            },
            Message: {
                closeLabel: 'Zamknij wiadomość',
            },
            SearchNavigation: {
                label: 'Pokaż wyszukiwanie',
                href: baseUrl + '/pl/search/',
                icon: 'arte-next-nav-search',
            },
            SiteMap: {
                title: 'Mapa strony',
                general: [
                    {
                        label: 'Strona główna',
                        href: baseUrl + '/pl/',
                        id: 'home',
                    },

                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/pl/arte-concert/',
                        id: 'concert',
                    },
                    {
                        label: 'Pokaż wyszukiwanie',
                        href: baseUrl + '/pl/search/',
                        id: 'search',
                    },
                ],

                categories: [
                    {
                        label: 'Polityka i społeczeństwo',
                        href: baseUrl + '/pl/videos/polityka-i-spoleczenstwo/',
                        id: 'ACT',
                    },
                    {
                        label: 'Kultura',
                        href: baseUrl + '/pl/videos/kultura/',
                        id: 'CPO',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/pl/arte-concert/',
                        id: 'ARS',
                    },
                    {
                        label: 'Nauka',
                        href: baseUrl + '/pl/videos/nauka/',
                        id: 'SCI',
                    },
                    {
                        label: 'Odkrycia',
                        href: baseUrl + '/pl/videos/odkrycia/',
                        id: 'DEC',
                    },
                    {
                        label: 'Historia',
                        href: baseUrl + '/pl/videos/historia/',
                        id: 'HIS',
                    },
                ],
                menuNavigation: [
                    { id: 'tvShows', label: 'Magazyny od A do Z', href: baseUrl + '/pl/videos/programy/' },
                    {
                        id: 'allVideos',
                        label: 'Wszystkie programy',
                        href: baseUrl + '/pl/videos/najczesciej-ogladane/',
                    },

                    { id: 'about', label: 'O nas', href: baseUrl + '/sites/corporate/pl/nasza-dzialalnosc/' },
                ],
            },
            Settings: {
                title: 'Ustawienia',
                href: baseUrl + '/pl/settings/',
            },
        },
        it: {
            Club: {
                home: 'Login to My ARTE',
                profile: 'Change my profile',
                login: 'Connessione',
                logout: 'Log out',
                pseudo: 'MyARTE',
            },
            Concert: {
                title: 'ARTE Concert',
                url: baseUrl + '/it/arte-concert/',
                navigation: {
                    label: 'Menu ARTE Concert',
                    links: [
                        {
                            label: 'Generi musicali',
                            href: baseUrl + '/it/arte-concert/piu-recenti/',
                            id: 'concert-genres',
                            kind: 'other',
                            tracking: {
                                target: null,
                                click_name: 'Parcourir_les_genres',
                                click_type: 'navigation',
                                categories: ['ARS_arte-concert', 'Header'],
                            },
                        },
                    ],
                },
                socialNetworks:{
                    facebook: null,
                    twitter: null,
                    instagram: null,
                    youtube: null,
                    twitch: null,
                },
                        concertSelectGenre:{
                    title:{label:"Generi musicali", href:baseUrl +"/it/arte-concert/piu-recenti/"},
                    items:[
                        {
                            label:"Pop & Rock",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=pop-rock"
                        },
                        {
                            label:"Elettronica",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=elettronica"
                        },
                        {
                            label:"Hip hop",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=hip-hop"
                        },
                        {
                            label:"Metal",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=metal"
                        },
                        {
                            label:"Musica classica",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=musica-classica"
                        },
                        {
                            label:"Opera",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=opera"
                        },
                        {
                            label:"Jazz",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=jazz"
                        },
                        {
                            label:"Musiche del mondo",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=musiche-del-mondo"
                        },
                        {
                            label:"Arti dello spettacolo",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=arti-dello-spettacolo"
                        },
                        {
                            label:"Musica barroca",
                            href:baseUrl +"/it/arte-concert/piu-recenti/?genres=musica-barocca"
                        },
                       
                    ]
               
            },
               guide:null,
            },
            DesktopNavigation: {
                ariaLabel: 'Menù secondario',
                links: [
                    {
                        label: 'Cerca',
                        href: baseUrl + '/it/search/',
                        id: 'search',
                    },
                    {
                        label: 'Chi siamo',
                        href: baseUrl + '/sites/it/corporate/cosa-facciamo/?lang=it',
                        id: 'about',
                    },
                ],
            },
            MenuNavigation: {
                ariaLabel: 'Menù principale',
                submenuLabel: 'Sottomenù {{category}}',
                mobileLinks: [
                    {
                        label: 'Inizio',
                        href: baseUrl + '/it/',
                    },
                    {
                        label: 'Cerca',
                        href: baseUrl + '/it/search/',
                        id: 'search',
                    },
                    {
                        label: 'Chi siamo',
                        href: baseUrl + '/sites/it/corporate/cosa-facciamo/?lang=it',
                        id: 'about',
                    },
                ],
                categories: [
                    {
                        description: 'Attualità e società',
                        label: 'Politica e società',
                        slug: 'politica-e-societa',
                        kind: 'internal',
                        href: baseUrl + '/it/videos/politica-e-societa/',
                        deeplink: 'arte://emac/ACT',
                        code: 'ACT',
                        icons: [],
                        links: [],
                    },
                    {
                        description: '',
                        label: 'Cinema',
                        slug: 'cinema',
                        kind: 'internal',
                        href: baseUrl + '/it/videos/cinema/',
                        deeplink: 'arte://emac/CIN',
                        code: 'CIN',
                        icons: [],
                        links: [],
                    },
                    {
                        description: '',
                        label: 'Serie',
                        slug: 'serie-e-fiction',
                        kind: 'internal',
                        href: baseUrl + '/it/videos/serie-e-fiction/',
                        deeplink: 'arte://emac/SER',
                        code: 'SER',
                        icons: [],
                        links: [],
                    },
                    {
                        description:
                            'Creazione contemporanea, cultutra pop e underground: i nuovi trend e i nuovi talenti.',
                        label: 'Cultura',
                        slug: 'cultura',
                        kind: 'internal',
                        href: baseUrl + '/it/videos/cultura/',
                        deeplink: 'arte://emac/CPO',
                        code: 'CPO',
                        icons: [],
                        links: [],
                    },
                    {
                        description: "I migliori spettacoli dal vivo, tutto l'anno. Come se ci fossi anche tu!",
                        label: 'ARTE Concert',
                        slug: 'arte-concert',
                        kind: 'internal',
                        href: baseUrl + '/it/arte-concert/',
                        deeplink: 'arte://emac/ARTE_CONCERT',
                        code: 'ARS',
                        icons: [],
                        links: [],
                    },
                    {
                        description: 'Scienze',
                        label: 'Scienze',
                        slug: 'scienze',
                        kind: 'internal',
                        href: baseUrl + '/it/videos/scienze/',
                        deeplink: 'arte://emac/SCI',
                        code: 'SCI',
                        icons: [],
                        links: [],
                    },
                    {
                        description: 'Viaggi e scoperte',
                        label: 'Viaggi e scoperte',
                        slug: 'viaggi-e-scoperte',
                        kind: 'internal',
                        href: baseUrl + '/it/videos/viaggi-e-scoperte/',
                        deeplink: 'arte://emac/DEC',
                        code: 'DEC',
                        icons: [],
                        links: [],
                    },
                    {
                        description: 'Storia',
                        label: 'Storia',
                        slug: 'storia',
                        kind: 'internal',
                        href: baseUrl + '/it/videos/storia/',
                        deeplink: 'arte://emac/HIS',
                        code: 'HIS',
                        icons: [],
                        links: [],
                    },
                ],
                otherLinks: [
                    {
                        label: 'Programmi',
                        slug: null,
                        href: baseUrl + '/it/videos/programmi/',
                        deeplink: null,
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Videogiochi',
                        slug: null,
                        href: baseUrl + '/digitalproductions/it/categories/videogiochi/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Tutti i video',
                        slug: null,
                        href: baseUrl + '/it/videos/piu-visti/',
                        deeplink: 'arte://programs/popular',
                        code: null,
                        kind: 'internal',
                        icons: null,
                        description: null,
                    },
                    {
                        label: 'Produzioni digitali',
                        slug: null,
                        href: baseUrl + '/digitalproductions/it/',
                        deeplink: null,
                        code: null,
                        kind: 'external',
                        icons: null,
                        description: null,
                    },
                ],
            },
            LogoNavigation: {
                label: 'in italiano',
                title: 'Arte in italiano',
                href: baseUrl + '/it/',
                links: [
                    {
                        label: 'ARTE Concert',
                        color: '#FF8BCA',
                        id: 'concert',
                        href: baseUrl + '/it/arte-concert/',
                    },  
                    {
                        label: 'Chi siamo',
                        href: baseUrl + '/sites/it/corporate/cosa-facciamo/?lang=it',
                        id: 'about',
                    },
                ],
            },
            Languages: {
                choseLangLabel: 'Cambia la lingua del sito. La lingua attuale è {{lang}}',
                languages: [
                    {
                        acronym: 'FR',
                        connectTitle: 'Se connecter',
                        href: baseUrl + '/fr/',
                        label: 'Français',
                        language: 'fr',
                        title: 'ARTE en 6 langues',
                    },
                    {
                        acronym: 'DE',
                        connectTitle: 'Einloggen',
                        href: baseUrl + '/de/',
                        label: 'Deutsch',
                        language: 'de',
                        title: 'ARTE in 6 Sprachen',
                    },
                    {
                        acronym: 'EN',
                        connectTitle: 'Log in',
                        href: baseUrl + '/en/',
                        label: 'English',
                        language: 'en',
                        title: 'ARTE in 6 languages',
                    },
                    {
                        acronym: 'ES',
                        connectTitle: 'Conectarse',
                        href: baseUrl + '/es/',
                        label: 'Español',
                        language: 'es',
                        title: 'ARTE en 6 idiomas',
                    },
                    {
                        acronym: 'PL',
                        connectTitle: 'Zaloguj',
                        href: baseUrl + '/pl/',
                        label: 'Polski',
                        language: 'pl',
                        title: 'ARTE w 6 językach',
                    },
                    {
                        acronym: 'IT',
                        connectTitle: 'Connessione',
                        href: baseUrl + '/it/',
                        label: 'Italiano',
                        language: 'it',
                        title: 'ARTE in 6 lingue',
                    },
                ],
            },
            InstallApp: "Installa l’app",
            RedirectionAnchor: {
                redirectMainLabel: 'Vai al contenuto principale',
                redirectSearchLabel: 'Vai alla ricerca',
            },
            Message: {
                closeLabel: 'Chiudi il messaggio',
            },
            SearchNavigation: {
                label: 'Mostra la ricerca',
                href: baseUrl + '/it/search/',
                icon: 'arte-next-nav-search',
            },
            SiteMap: {
                title: 'Site map',
                general: [
                    {
                        label: 'Home',
                        href: baseUrl + '/it/',
                        id: 'home',
                    },

                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/it/arte-concert/',
                        id: 'concert',
                    },
                    {
                        label: 'Mostra la ricerca',
                        href: baseUrl + '/it/search/',
                        id: 'search',
                    },
                ],

                categories: [
                    {
                        label: 'Politica e società',
                        href: baseUrl + '/it/videos/politica-e-societa/',
                        id: 'ACT',
                    },
                    {
                        label: 'Cultura',
                        href: baseUrl + '/it/videos/cultura/',
                        id: 'CPO',
                    },
                    {
                        label: 'ARTE Concert',
                        href: baseUrl + '/it/arte-concert/',
                        id: 'ARS',
                    },
                    {
                        label: 'Scienze',
                        href: baseUrl + '/it/videos/scienze/',
                        id: 'SCI',
                    },
                    {
                        label: 'Viaggi e scoperte',
                        href: baseUrl + '/it/videos/viaggi-e-scoperte/',
                        id: 'DEC',
                    },
                    {
                        label: 'Storia',
                        href: baseUrl + '/it/videos/storia/',
                        id: 'HIS',
                    },
                ],
                menuNavigation: [
                    { id: 'tvShows', label: 'Transmissioni da A a Z', href: baseUrl + '/pl/videos/programy/' },
                    { id: 'allVideos', label: 'Tutti i video', href: baseUrl + '/it/videos/piu-visti/' },

                    { id: 'about', label: 'Chi siamo', href: baseUrl + '/sites/corporate/it/cosa-facciamo/' },
                ],
            },
            Settings: {
                title: 'Impostazioni',
                href: baseUrl + '/it/settings/',
            },
        },
    };
});

exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
/* No side effect */
